<template>
  <div>
    <header class="d-flex a-center j-between mb-10">
      <!-- <div class="d-flex a-center">
        <el-cascader style="margin-left:10px" :options="experTreeList" @change="setIdChange" clearable placeholder="请选择实验" :props="{ expandTrigger: 'hover', label: 'itemname', value: 'itemid', emitPath: false }" :show-all-levels="false"></el-cascader>
      </div> -->
      <div>
        <el-button class="mr-10" type="" icon="el-icon-download" round @click="downLoadHandle">下载导入模板</el-button>
        <el-upload class="mr-10" style="display:inline-block" :action="action" :limit="3" name="file" :headers="upLoadHeaders" :show-file-list="false" :on-success="handleUploadSuccess">
          <el-button type="" icon="el-icon-upload" round>批量导入</el-button>
        </el-upload>
        <el-button type="primary" icon="el-icon-plus" round @click="addHandle">添加</el-button>
      </div>
    </header>
    <div class="p-10 bg-white">
      <el-table :data="steps" max-height="650" empty-text="暂无大步骤" border>
        <el-table-column label="序号" type="index" align="center" width="55"></el-table-column>
        <el-table-column label="步骤名称" prop="itemname" align="center"></el-table-column>
        <el-table-column label="步骤编号" prop="itemcode" align="center"></el-table-column>
        <el-table-column label="大步骤号" prop="stepnum" align="center"></el-table-column>
        <el-table-column label="小步骤号" prop="sortcode" align="center"></el-table-column>
        <el-table-column label="序号" prop="ordernum" align="center"></el-table-column>
        <el-table-column label="创建时间" sortable prop="createdate" align="center"></el-table-column>
        <el-table-column label="备注" prop="description" align="center"></el-table-column>
        <el-table-column label="操作" align="center" width="200px">
          <template slot-scope="scope">
            <el-button type="text" icon="el-icon-delete" @click="delHandle(scope.row)">删除</el-button>
            <el-button type="text" icon="el-icon-edit" @click="updateHandle(scope.row)">修改</el-button>
          </template>
        </el-table-column>
      </el-table>
      <base-pagination :total="total" :pagesize.sync="params.pagesize" :pageindex.sync="params.pageindex" />
    </div>

    <el-dialog title="编辑实验步骤" :visible.sync="open">
      <el-form :model="formData" :rules="rules" ref="ruleForm" label-width="100px">
        <el-form-item label="实验id" prop="itemcode">
          <el-cascader v-model="experimentid" style="margin-left:10px" :options="experTreeList" @change="setIdChange" clearable placeholder="请选择实验" :props="{ expandTrigger: 'hover', label: 'itemname', value: 'itemid', emitPath: false }" :show-all-levels="false"></el-cascader>
        </el-form-item>
        <el-form-item label="上级步骤" prop="parentid">
          <el-select v-model="formData.parentid" placeholder="请选择上级步骤">
            <el-option v-for="item in steps" :key="item.experimentstepid" :label="item.itemname" :value="item.experimentstepid"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="步骤编号" prop="itemcode">
          <el-input v-model="formData.itemcode" placeholder="请输入步骤编号"></el-input>
        </el-form-item>
        <el-form-item label="步骤名称" prop="itemname">
          <el-input v-model="formData.itemname" placeholder="请输入步骤名称"></el-input>
        </el-form-item>
        <el-form-item label="大步骤号" prop="stepnum">
          <el-input v-model="formData.stepnum" placeholder="请输入大步骤号"></el-input>
        </el-form-item>
        <el-form-item label="小步骤号" prop="sortcode">
          <el-input v-model="formData.sortcode" placeholder="请输入步骤号"></el-input>
        </el-form-item>
        <!-- <el-form-item label="步骤分数" prop="stepallscore">
          <el-input-number
            v-model="formData.stepallscore"
            placeholder="请输入步骤分数"
            :min="0"
          ></el-input-number>
        </el-form-item> -->
        <el-row>
          <!-- <el-col :span="12">
            <el-form-item label="合理用时(秒)" prop="expercttime">
              <el-input-number v-model="formData.expercttime" :min="0"></el-input-number>
            </el-form-item>
          </el-col> -->
          <el-col :span="12">
            <el-form-item label="排序" prop="ordernum">
              <el-input-number v-model="formData.ordernum" :min="0"></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="备注" prop="description">
          <el-input v-model="formData.description" type="textarea" placeholder=""></el-input>
        </el-form-item>
        <el-form-item label="">
          <el-button type="primary" @click="submitHandle">保存</el-button>
          <el-button type="" @click="open = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import base from '../../../api/base'
import Api from '../../../api/index'
import basePagination from '../../../components/basePagination.vue'
// import { DownloadImportTemp } from '@/api/file'
// import { getToken } from '@/utils/auth.js'
export default {
  components: {
    basePagination
  },
  data() {
    return {
      total: 0,
      experTreeList: [],
      experimentid: '',
      // 步骤列表
      steps: [],
      params: {
        pageindex: 1,
        pagesize: 10000
      },
      formData: {},
      rules: {},
      open: false,
      upLoadHeaders: {
        Authorization: 'Bearer ' + window.localStorage.getItem('token')
      },
      action: base.qa + '/MedicineExperimentsteps/ImportExperSteps'
    }
  },
  computed: {
    projectname: function() {
      return this.$route.query.projectname
    }
  },
  created() {
    this.GetExperTree()
    this.getBSteps()
  },
  methods: {
    async GetExperTree() {
      const res = await Api.sum.GetExperTree()
      this.experTreeList = res.rows
    },
    setIdChange(val) {
      console.log(val, 'ddd')
      this.experimentid = val
      this.formData.experimentid = val
    },
    async getBSteps() {
      const res = await Api.steps.GetDataList(this.params)
      if (!res.success) return this.$message.error(res.msg)
      this.steps = res.rows
    },
    resetForm() {
      this.formData = {
        parentid: null,
        itemcode: '',
        itemname: '',
        stepnum: '',
        sortcode: '',
        stepallscore: '',
        expercttime: '',
        ordernum: '',
        description: '',
        experimentid: ''
      }
      this.experimentid = ''
    },
    addHandle() {
      this.open = true
      this.resetForm('ruleForm')
    },
    submitHandle() {
      this.$refs.ruleForm.validate(async val => {
        if (!val) return
        const params = {
          ...this.formData
        }
        Object.assign(params, {
          experimentid: this.experimentid
        })
        const res = await Api.steps.SaveData(params)
        if (!res.success) return this.$message.error(res.msg)
        this.open = false
        this.getBSteps()
      })
    },
    delHandle(row) {
      this.$confirm('确认删除？此操作将无法恢复', '删除警告', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          const res = await Api.steps.DelData([row.experimentstepid])
          if (!res.success) return this.$message.error(res.msg)
          this.$message.success(res.msg)
          this.getBSteps()
        })
        .catch(() => {})
    },
    // 下载导入模板
    async downLoadHandle() {
      const res = await DownloadImportTemp('实验步骤导入模板')
      if (!res.success) return this.$message.error(res.msg)
      window.open(res.rows.url)
    },
    // 批量导入
    handleUploadSuccess(response, file) {
      if (!response.success) return this.$message.error(response.msg)
      this.$message.success(response.msg)
      this.getBSteps()
    },
    updateHandle(row) {
      this.resetForm('ruleForm')
      this.formData = row
      this.experimentid = row.experimentid
      console.log(this.formData, 'row')
      this.open = true
    },
    stepQHandle(row) {
      this.$router.push({
        name: 'MyExpStepsQuestions',
        query: {
          stepno: row.stepnum,
          orderno: row.sortcode,
          experimentid: this.$route.query.experimentid
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.left {
  width: 250px;
  min-height: 600px;
  border: 1px solid #eee;
  h3 {
    margin: 0;
    padding: 10px 0;
    // background-color: $primary;
    text-align: center;
    color: #fff;
  }
}
.right {
  flex: 1;
}
::v-deep .el-table td,
.el-table th {
  padding: 0;
}
</style>

